module.exports = __webpack_public_path__ + "static/media/libro19.d7f5cbc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro19.png
// module id = 367
// module chunks = 0